/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponsePagedResultAllConversationSearchDto } from '../models/api-response-paged-result-all-conversation-search-dto';
import { deleteConversation } from '../fn/conversation-admin-api/delete-conversation';
import { DeleteConversation$Params } from '../fn/conversation-admin-api/delete-conversation';
import { listOfAllConversations } from '../fn/conversation-admin-api/list-of-all-conversations';
import { ListOfAllConversations$Params } from '../fn/conversation-admin-api/list-of-all-conversations';

@Injectable({ providedIn: 'root' })
export class ConversationAdminApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listOfAllConversations()` */
  static readonly ListOfAllConversationsPath = '/v1/api/admin-ui/conversation/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listOfAllConversations()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listOfAllConversations$Response(params: ListOfAllConversations$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAllConversationSearchDto>> {
    return listOfAllConversations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listOfAllConversations$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listOfAllConversations(params: ListOfAllConversations$Params, context?: HttpContext): Observable<ApiResponsePagedResultAllConversationSearchDto> {
    return this.listOfAllConversations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultAllConversationSearchDto>): ApiResponsePagedResultAllConversationSearchDto => r.body)
    );
  }

  /** Path part for operation `deleteConversation()` */
  static readonly DeleteConversationPath = '/v1/api/admin-ui/conversation/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConversation$Response(params: DeleteConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConversation(params: DeleteConversation$Params, context?: HttpContext): Observable<void> {
    return this.deleteConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
